<template>
	<div :style="mainStyle" class="wrapper">
			<div class="logo">
				<img style="width: 210px;height: 100px;" src="https://cdn.meetingmeet.com/logo/420200.png">
			</div>
			<el-tabs class="box-card" v-model="activeName" :stretch="true" type="border-card">
				<el-tab-pane label="密码登录" name="loginMethodPassword" class="tab-panel">
					<el-form class="login-form" :hide-required-asterisk="true"
						:model="loginForm"
						:rules="rules"
						v-loading="loading"
						ref="loginForm">
						<el-form-item label="请输入用户手机号码" prop="username">
							<el-input v-model="loginForm.username" placeholder="请输入您的手机号码"></el-input>
						</el-form-item>
						<el-form-item label="请输入密码" prop="password">
							<el-input v-model="loginForm.password" type="password" placeholder="请输入密码"
												@keyup.enter.native="loginWithPassword('loginForm')"></el-input>
						</el-form-item>
						<el-button class="login-btn" type="primary" @click="loginWithPassword('loginForm')">登录</el-button>
						<div style="line-height: 30px;margin-top: 10px;font-size: 14px;text-decoration: underline;color:#409EFF;cursor: pointer;">
							<!--<span @click="register" style="width: 50%;display: inline-block;">立即免费注册</span>-->
							<span @click="fogetPassword" style="width: 100%;display: inline-block;text-align: right;">忘记密码?</span>
						</div>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="验证码登录" name="loginMethodCode">
					<el-form class="login-form" :hide-required-asterisk="true"
									 :model="loginForm"
									 :rules="rulesCode"
									 v-loading="loading"
									 ref="loginFormWithCode">
						<el-form-item label="请输入用户手机号码" prop="username">
							<el-input v-model="loginForm.username" placeholder="请输入您的手机号码"></el-input>
						</el-form-item>
						<el-form-item label="请输入验证码" prop="code" class="login-code-item" >
							<el-input v-model="loginForm.code" placeholder="请输入验证码"
												@keyup.enter.native="loginWithCode('loginForm')">
								<template>
									<template slot="append">
										<el-button @click="getLoginCode" class="code-btn" :disabled="codeBtnDisabled">{{loginCodeMsg}}</el-button>
									</template>
								</template>
							</el-input>
						</el-form-item>
						<el-button class="login-btn" type="primary" @click="loginWithCode('loginFormWithCode')">登录</el-button>
						<div style="line-height: 30px;margin-top: 10px;font-size: 14px;text-decoration: underline;color:#409EFF;cursor: pointer;">
							<span @click="register" style="width: 50%;display: inline-block;">立即免费注册</span><span @click="fogetPassword" style="width: 50%;display: inline-block;text-align: right;">忘记密码?</span>
						</div>
					</el-form>
				</el-tab-pane>
			</el-tabs>
	</div>

</template>
<script>
import ElFormItem from '../../node_modules/element-ui/packages/form/src/form-item.vue'
import config from "../../config/global.js";

var loginUrl = config.host+"/backend/signin.json";
var loginWithCodeUrl = config.host+"/backend/signincode.json";
var getCodeUrl = config.host+"/backend/getusercode.json";

export default {
  components: {ElFormItem},
  data () {
    return {
			mainStyle:{"height":window.innerHeight+"px"},
			activeName:"loginMethodPassword",
			loginForm: {
        username: "",
        password: "",
				code:""
      },
      error: "",
			timer:null,
			fetching:false,
			loginCodeMsg:"获取验证码",
			codeBtnDisabled:false,
      loading: false,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
			rulesCode: {
				username: [
					{ required: true, message: '请输入用户名', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入验证码', trigger: 'blur' }
				]
			},
    }
  },
  methods: {
		loginWithPassword (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
				 this.loading=true;
				 var params = {"phone":this.loginForm.username,"password":this.loginForm.password};
				 this.$http.post(loginUrl,params).then(
						 function(response){
							  var res = response.body;
							 this.loading=false;
								if(res.result==1){
									var userInfo = {};
									userInfo.name = res.name;
									userInfo.orgname = res.orgname;
									userInfo.phone = res.phone;
									userInfo.type = res.type;
									userInfo.orglogo = res.orglogo;
									this.$store.commit("setUserInfo",userInfo);
									this.$router.replace({"name":"productquery"});
								}else{
									this.$message.error(res.emsg);
								}
						 },function(){
						 		this.$message.error("登录失败");
								 this.loading=false;
						 })
        } else {
          return false
        }
      })
    },
		loginWithCode:function (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading=true;
					var params = {"phone":this.loginForm.username,"code":this.loginForm.code};
					this.$http.post(loginWithCodeUrl,params).then(
						function(response){
							var res = response.body;
							if(res.result==1){
								var userInfo = {};
								userInfo.name = res.name;
								userInfo.orgname = res.orgname;
								userInfo.phone = res.phone;
								userInfo.type = res.type;
								userInfo.orglogo = res.orglogo;
								this.$store.commit("setUserInfo",userInfo);
								//首次登录，去设置密码
								if(res.status == 0){
									this.$router.replace({"name":"active"});
								}else{
									this.$router.replace({"name":"productquery"});
								}

							}else{
								this.$message.error(res.emsg);
							}
							this.loading=false;
						},function(){
							this.$message.error("登录失败");
							this.loading=false;
						})
				} else {
					return false
				}
			})
		},
    resetForm(formName) {
			this.$refs[formName].resetFields();
			this.error = '';
    },
		getLoginCode:function () {
			if(this.loginForm.username == ""){
				this.$message.error("手机号码不能为空");
				return;
			}
			if(this.loading == false && this.fetching == false ){
				this.fetching = true;
				this.loading == true;
				var params = {"phone":this.loginForm.username,"type":2};
				this.$http.post(getCodeUrl,params).then(
					function(response){
						var res = response.body;
						this.buildCodeMsg();
						if(res.result==1){
							this.$message({
								message: "验证码已发送",
								type: "success"
							});
						}else{
							this.$message.error(res.emsg);
						}
						this.loading=false;
						this.fetching = false;
					},function(){
						this.$message.error("获取验证码失败");
						this.loading=false;
						this.fetching = false;
					})
			}
		},
		buildCodeMsg:function () {
			var cSecond = 60;
			this.loginCodeMsg = "重新发送("+cSecond+")";
			if(this.timer != null)
				clearInterval(this.timer);
			this.codeBtnDisabled = true;
			var _this = this;
			this.timer = setInterval(function(){
				cSecond--;
				_this.loginCodeMsg = "重新发送("+cSecond+")";
				if(cSecond == 0){
					_this.loginCodeMsg = "获取验证码";
					_this.fetching = false;
					_this.codeBtnDisabled = false;
					clearTimeout(_this.timer);
				}
			},1000);
		},
		fogetPassword:function () {
			this.$router.replace({"name":"forgetpassword"});
		},
		register:function () {
			this.$router.replace({"name":"register"});
		}
  }
}
</script>

<style scoped>
	.wrapper{
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-image: url(https://cdn.meetingmeet.com/images/signup-bg.png);
		background-size: cover;
	}

	.logo{
		text-align: center;
		margin-top: -200px;
		padding-bottom: 20px;
	}

	.wrapper>>>.el-card__body{
		padding: 0px;
	}

	.wrapper>>>.el-form-item__label{
		color: rgb(175, 175, 175);
		font-size: 13px;
		font-weight: 400;
	}
	.wrapper>>>.el-tabs__item.is-top{
		line-height: 50px;
		height: 50px;
		font-size: 18px;
	}
	.wrapper>>>.el-tabs__content{
		padding: 15px 25px;
	}

	.wrapper>>>.el-form-item{
		margin-bottom: 0px;
	}

	.wrapper>>>.el-input__inner{
		border: 1px solid #eaeff1;
		background: #fbfbfb;
		box-shadow: none;
		border-radius: 3px;
		height: 40px;
		font-size: 12px;
		padding: 4px 16px;
	}

	.wrapper>>>.el-input__inner:focus{
		border-color: #409EFF;
		outline: 0;
		box-shadow: 0 0 8px #409EFF;
	}

	.wrapper>>>.el-form-item.is-error .el-input__inner{
		border-color: #F56C6C;
		box-shadow: 0 0 8px #F56C6C;
	}

	.wrapper>>>.el-form-item__error{
		color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		position: absolute;
		top: 40px;
		right: 10px;
		line-height: 40px;
		padding-top: 0px;
		left: inherit;
	}

	.wrapper>>>.login-code-item .el-form-item__error {
		right: 130px;
	}

    .box-card{
      width:450px;
			height: 350px;
			border-radius: 0 0 5px 5px;
    }
    .title{
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-size: 22px;
        text-align: center;
        margin: 20px auto 30px ;
    }
    .error{
        text-align: center;
        color: red;
        margin: -10px 0 10px 0;
    }

	.tab-panel{
		width: 100%;
		height: 100%;
	}

	.login-form{
		width: 100%;
		height: 280px;
	}

	.login-btn{
		width: 100%;
		margin-top: 40px;
	}

	.code-btn{
		width: 125px;
		font-size: 13px;
	}

	.el-button.is-disabled{
		color: #C0C4CC;
		cursor: not-allowed;
		background-image: none;
		background-color: #FFF;
		border-color: #EBEEF5;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue